import React from 'react';
import { useTranslation } from 'react-i18next';
import './RintintinLoaderNative.css';

export interface RintintinLoaderNativeProps {
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  fullscreen?: boolean;
  text?: string;
  variant?: 'primary' | 'white' | 'dark';
  compact?: boolean;
  className?: string;
}

/**
 * Loader native — Spring Dots (même animation que le web).
 */
const RintintinLoaderNative: React.FC<RintintinLoaderNativeProps> = ({
  size = 'large',
  fullscreen = false,
  text,
  variant = 'primary',
  compact = false,
  className = '',
}) => {
  const { t } = useTranslation('common');
  const layoutClass = fullscreen
    ? 'rintintin-loader-native--fullscreen'
    : compact
      ? 'rintintin-loader-native--compact'
      : 'rintintin-loader-native--inline';

  return (
    <div
      className={[
        'rintintin-loader-native',
        `rintintin-loader-native--${size}`,
        `rintintin-loader-native--${variant}`,
        layoutClass,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={text || t('loading')}
    >
      <div className="rintintin-loader-native__dots">
        <span className="rintintin-loader-native__dot rintintin-loader-native__dot--0" />
        <span className="rintintin-loader-native__dot rintintin-loader-native__dot--1" />
        <span className="rintintin-loader-native__dot rintintin-loader-native__dot--2" />
      </div>
      {text ? (
        <p className={`rintintin-loader-native__text rintintin-loader-native__text--${variant}`}>
          {text}
        </p>
      ) : null}
    </div>
  );
};

export default RintintinLoaderNative;
